import { useContext } from 'react';
import CandleContext from './context';

export const useCandleContext = () => useContext(CandleContext);
